import axios from 'axios';
import { getAccessToken, getAuth0Plugin } from '@/authentication/auth0';

const setupAxiosRequestInterceptor = () => {
    axios.interceptors.request.use(async (config) => {
        const alreadyHasAuth = Boolean(config.headers?.Authorization);

        if (!alreadyHasAuth) {
            try {
                if (getAuth0Plugin().isAuthenticated.value) {
                    config.headers.Authorization = `Bearer ${await getAccessToken()}`;
                }
            } catch (e) {
                console.error('[auth0] getAccessToken failed for', config.url, e);
            }
        }

        return config;
    });
};

const setupAxiosResponseInterceptor = () => {
    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            const is401 = error.response && error.response.status === 401;
            const isAlreadyLoggingOut = window.location.pathname === '/logout';

            if (is401 && !isAlreadyLoggingOut) {
                if (!error.config?.__authRetry) {
                    // Retry once with a fresh token before bouncing to /logout.
                    try {
                        const token = await getAccessToken({ ignoreCache: true });

                        error.config.__authRetry = true;
                        error.config.headers = error.config.headers ?? {};
                        error.config.headers.Authorization = `Bearer ${token}`;

                        return axios.request(error.config);
                    } catch (_refreshError) {
                        window.location.assign('/logout');
                    }
                } else {
                    window.location.assign('/logout');
                }
            }

            if (error.response && error.response.status === 451) {
                const { useAuthStore } = await import('@/stores/auth');

                useAuthStore().resetTermsAccepted();
            }

            return Promise.reject(error);
        },
    );
};

export const setupInterceptors = () => {
    setupAxiosRequestInterceptor();

    setupAxiosResponseInterceptor();
};
